// Lib
import DefaultCodeMark from '@tiptap/extension-code';

/**
 * Supports formatting within inline code blocks
 */
export const CodeMark = DefaultCodeMark.extend({
    marks: 'textStyle highlight bold italic underline strike link',

    // Needs to be more than text style (101) and link (1000) so that the <code> tag wraps the <a> or <span> tag
    priority: 1001,
});
